import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AuthService } from './auth/auth.service';
import { GlobalState } from './global.state';
import { CoreModule } from './core/core.module';
import { DashboardModule } from './pages/dashboard/dashboard.module';

import { CompaniesModule } from './pages/companies/companies.module';


import { SharedModule } from './shared/shared.module';

import { AuthModule } from './auth/auth.module';
import { DataService } from './data.service';
import { FormErrorsService } from './form-errors.service';


import { AppComponent } from './app.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    DashboardModule,
    NgbModule.forRoot(),
    AppRoutingModule,
    AuthModule,
    CompaniesModule,
    BrowserAnimationsModule,
    SharedModule
  ],
  providers: [AuthService, GlobalState, DataService, FormErrorsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/app.module.ts